
import { defineComponent, computed } from 'vue'
import { colorValidator } from '@/views/validation'

export default defineComponent({
  props: {
    message: {
      type: String as () => string | null,
      default: null
    },
    color: {
      type: String,
      required: true,
      validator: colorValidator
    }
  },
  emits: {
    dismiss: () => true
  },
  setup (props, { emit }) {
    const alertColor = computed(() => 'alert-' + props.color)

    const onClickDismiss = () => {
      emit('dismiss')
    }

    return {
      alertColor,
      onClickDismiss
    }
  }
})
